import { useCSSVariable } from 'uniwind'

type CustomThemeColor =
    | 'rail-background'
    | 'rail-text'
    | 'rail-active-text'
    | 'sidebar-background'
    | 'active-indicator'
    | 'hover-background'
    | 'info'
    | 'info-foreground'
    | 'muted-foreground'
    | 'primary'
    | 'primary-foreground'

type BuiltInThemeColor =
    | 'background'
    | 'foreground'
    | 'surface'
    | 'surface-foreground'
    | 'surface-hover'
    | 'overlay'
    | 'overlay-foreground'
    | 'overlay-backdrop'
    | 'muted'
    | 'accent'
    | 'accent-foreground'
    | 'segment'
    | 'segment-foreground'
    | 'border'
    | 'separator'
    | 'focus'
    | 'link'
    | 'default'
    | 'default-foreground'
    | 'success'
    | 'success-foreground'
    | 'warning'
    | 'warning-foreground'
    | 'danger'
    | 'danger-foreground'
    | 'field'
    | 'field-foreground'
    | 'field-placeholder'
    | 'field-border'
    | 'background-secondary'
    | 'background-tertiary'
    | 'background-inverse'
    | 'default-hover'
    | 'accent-hover'
    | 'success-hover'
    | 'warning-hover'
    | 'danger-hover'
    | 'field-hover'
    | 'field-focus'
    | 'field-border-hover'
    | 'field-border-focus'
    | 'accent-soft'
    | 'accent-soft-foreground'
    | 'accent-soft-hover'
    | 'danger-soft'
    | 'danger-soft-foreground'
    | 'danger-soft-hover'
    | 'warning-soft'
    | 'warning-soft-foreground'
    | 'warning-soft-hover'
    | 'success-soft'
    | 'success-soft-foreground'
    | 'success-soft-hover'
    | 'surface-secondary'
    | 'unread-background'
    | 'surface-tertiary'
    | 'on-surface'
    | 'on-surface-foreground'
    | 'on-surface-hover'
    | 'on-surface-focus'
    | 'on-surface-secondary'
    | 'on-surface-secondary-foreground'
    | 'on-surface-secondary-hover'
    | 'on-surface-secondary-focus'
    | 'on-surface-tertiary'
    | 'on-surface-tertiary-foreground'
    | 'on-surface-tertiary-hover'
    | 'on-surface-tertiary-focus'
    | 'separator-secondary'
    | 'separator-tertiary'
    | 'border-secondary'
    | 'border-tertiary'

export type AppThemeColor = BuiltInThemeColor | CustomThemeColor

export function useThemeColor(color: AppThemeColor): string {
    return String(useCSSVariable(`--color-${color}`) ?? '')
}
